<div class="td-wb-menu-page__container">
  @for (group of flattenLocalNavigation; track group) {
    @if (group.text && group.menu[0].item.length > 0) {
      <div
        class="td-wb-menu-page">
        <div class="td-wb-menu-page__header"
             [innerText]="group.text"></div>
        <div class="td-wb-menu-page__links">
          <ul [attr.aria-label]="group.text">
            @for (link of group.menu[0].item; track link) {
              <li class="td-wb-menu-page__link">
                <a [attr.target]="link.target"
                   [href]="link.href">
                  <span [innerText]="link.text"></span>
                  <td-wb-icon iconId="caret-right--small"
                              [inline]="true" />
                </a>
              </li>
            }
          </ul>
        </div>
      </div>
    }
  }
</div>


